/*
 * @Description: '首页'所有的路由
 * @Author: mike ma *
 * @Date: 2021-02-24 16:50:00
 * @LastEditTime: 2021-03-03 20:12:42
*/

export default [
    {
        path: 'home', //path: '',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home',
        meta: {
            nav: '首页'
        }
    },
    {
        path: 'home',
        component: resolve => require(['@/views/home'], resolve),
        name: 'Home-2',
        meta: {
            nav: '首页'
        }
    }

]



// WEBPACK FOOTER //
// ./src/router/home.js